export const EVALUATION_STEP_TYPE = {
  ACTIVITIES: 'activities',
  ACTIVITIES_TYPE: 'activitiesType',
  BASIC_DATA: 'basicData',
  BOOK: 'book',
  INFORMATION_DATA: 'informationData',
  LAST_STEP: 'lastStep',
  UNITS: 'units',
}

export const STEPS_TYPES_KEYS = {
  ACTIVITIES: 'ACTIVITIES',
  ACTIVITY_TYPES: 'ACTIVITY_TYPES',
  BASIC_DATA: 'BASIC_DATA',
  BOOK: 'BOOK',
  CREATE_EVALUATION: 'CREATE_EVALUATION',
  INFORMATION_DATA: 'INFORMATION_DATA',
  UNITS: 'UNITS',
}

export const STEPS_EVALUATIONS = [
  { key: STEPS_TYPES_KEYS.BOOK, number: 1 },
  { key: STEPS_TYPES_KEYS.BASIC_DATA, number: 2 },
  { key: STEPS_TYPES_KEYS.UNITS, number: 3 },
  { key: STEPS_TYPES_KEYS.ACTIVITY_TYPES, number: 4 },
  { key: STEPS_TYPES_KEYS.ACTIVITIES, number: 5 },
  { key: STEPS_TYPES_KEYS.INFORMATION_DATA, number: 6 },
]

export const TYPE_FILTER_ACTIVITY = {
  EVALUATION_CRITERIA: 'EVALUATION_CRITERIA',
  SPECIFIC_COMPTENCIES: 'SPECIFIC_COMPTENCIES',
}
export const MIN_PAGE = 1
